import React, { Suspense, useCallback } from 'react'
import { PlaceWorld } from '@fs/zion-icon'
import { Button, useOverlay } from '@fs/zion-ui'
import { availableLangs, i18n } from '@fs/zion-locale'
import { useTranslation } from 'react-i18next'
import { trackEvent } from '@fs/zion-analytics'

const LangPicker = React.lazy(() => import('@fs/zion-lang-picker'))

function findLang(code, translate) {
  const allAvailableLangs = availableLangs.core.concat(availableLangs.additional)
  const currentLang = allAvailableLangs.find((element) => element.code === code)
  if (currentLang) return currentLang.text

  return translate('common-ui:language.label', 'Language')
}

export default function LanguageLink() {
  const overlay = useOverlay()
  const { t } = useTranslation()
  const langText = findLang(i18n.language, t)
  const selectLangText = t('footer.language-link.action', 'Select a Language')

  const openLanguagePicker = useCallback(
    (event) => {
      overlay.open(event)
      trackEvent({ event_name: 'footer:languagePicker:clicked' })
    },
    [overlay]
  )

  return (
    <Suspense fallback={<Button Icon={PlaceWorld}>{t('common-ui:loading.ellipsis.label', 'Loading...')}</Button>}>
      <Button Icon={PlaceWorld} onClick={openLanguagePicker} aria-label={`${selectLangText}: ${langText}`}>
        {langText}
      </Button>
      {overlay.isOpen && <LangPicker overlay={overlay} />}
    </Suspense>
  )
}
